export default __webpack_public_path__ + "static/media/history5.77af2328.png";